export type UserRole = 'admin' | 'hr';

export interface RouteConfig {
  path: string;
  component: React.ComponentType;
  roles: UserRole[];
}

export interface MenuConfig {
  key: string;
  path: string;
  label: string;
  icon: React.ReactNode;
  roles: UserRole[];
}

export const ROUTE_PERMISSIONS: Record<string, UserRole[]> = {
  '/profile': ['admin', 'hr'],
  '/jobs-management': ['admin', 'hr'],
  '/job-submissions-management': ['admin', 'hr'],
  '/contacts-management': ['admin', 'hr'],
  '/blogs-management': ['admin'],
  '/cultures-management': ['admin'],
  '/users-management': ['admin']
};

export const MENU_PERMISSIONS: Record<string, UserRole[]> = {
  'jobs-management': ['admin', 'hr'],
  'job-submissions-management': ['admin', 'hr'],
  'contacts-management': ['admin', 'hr'],
  'blogs-management': ['admin'],
  'cultures-management': ['admin'],
  'users-management': ['admin']
};

export const canAccessRoute = (userRole: string | undefined, route: string): boolean => {
  if (!userRole) return false;
  const allowedRoles = ROUTE_PERMISSIONS[route];
  return allowedRoles?.includes(userRole as UserRole) || false;
};

export const canAccessMenu = (userRole: string | undefined, menuKey: string): boolean => {
  if (!userRole) return false;
  const allowedRoles = MENU_PERMISSIONS[menuKey];
  return allowedRoles?.includes(userRole as UserRole) || false;
}; 